import React from "react";
import { useEffect, useState } from 'react';
import { Form, Button, Table, Col, Row, Container } from 'react-bootstrap';
import { capitalizeFirstLetter } from '../Shared/Helpers';
import { v4 as uuidv4 } from 'uuid';
import { isEmpty } from "lodash";
import SweetAlert from "react-bootstrap-sweetalert";
import ReactDatetime from "react-datetime";
import "assets/scss/_error.scss";

const ErrorPage = (props) => {
    return (
        <Container fluid className="error-container">
            <Col className="error-col">
                <h1 className="error-heading">Oops!</h1>
                <p className="error-text">
                    We can't seem to find the page you're looking for.
                </p>
                <Button className="error-button" variant="primary" href="/">
                   Back To Jobs Home
                </Button>
            </Col>
        </Container>
    );
}
export default ErrorPage;
